import { GET_ALL_CONFERENCES, GET_REPORT_DATA } from './mutation-types'
import relatorioConferenciasHttpService from '../_services/relatorioConferenciasHttpService'

export default {
  listarTodasAsConferencias: async ({ commit }) => {
    try {
      const response = await relatorioConferenciasHttpService.getConferencias()
      commit(GET_ALL_CONFERENCES, response.data)
    } catch (e) {
      console.log(e)
    }
  },

  gerarDadosRelatorio: async ({ commit }, form) => {
    try {
      const response = await relatorioConferenciasHttpService.postRelatorioConferencias(form)
      commit(GET_REPORT_DATA, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
